(function (root, factory) {
  const pageTrackingUtils = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = pageTrackingUtils;
    return;
  }

  if (root) {
    root.pageTrackingUtils = pageTrackingUtils;
  }
})(typeof window !== 'undefined' ? window : undefined, function createPageTrackingUtils() {
  const depthThresholds = [25, 50, 75, 100];
  const commonFieldKeys = [
    'sessionId',
    'userId',
    'deviceType',
    'os',
    'browser',
    'timestamp',
    'pageUrl',
    'referrer',
    'country',
    'language'
  ];
  const basicInfoKeys = ['userId', 'projectId'];

  function fillEmptyValue(value) {
    if (value === null || value === undefined) {
      return '';
    }

    return String(value);
  }

  function extractBrowserFromUserAgent(userAgent) {
    const ignoredTokens = {
      mozilla: true,
      applewebkit: true,
      khtml: true,
      like: true,
      gecko: true,
      version: true,
      mobile: true,
      compatible: true
    };
    const productTokens = userAgent.match(/[a-z][a-z0-9_-]*(?=\/[\d.]+)/g) || [];

    for (let index = productTokens.length - 1; index >= 0; index -= 1) {
      const token = productTokens[index];

      if (!ignoredTokens[token]) {
        return token;
      }
    }

    return '';
  }
  
  function resolvePageIdentity(context) {
    const currentContext = context || {};
    const pageType = fillEmptyValue(currentContext.pageType);
    const requestPath = currentContext.requestPath;
    const pageId = currentContext.pageId;

    if (pageType === 'index') {
      return {
        // pageName: 'HomePage',
        pageName: document.title,
        subPageName: '',
        pageId,
      };
    } else if (requestPath.endsWith('/pages/rayneo-air-4-pro-launch-best-ar-glasses')) {
      return {
        // pageName: 'Air 4Pro',
        pageName: document.title,
        subPageName: 'Standard Edition',
        pageId
      };
    } else if (requestPath.endsWith('/pages/best-ar-glasses-rayneo-air-4-pro-launch')) {
      return {
        // pageName: 'Air 4Pro',
        pageName: document.title,
        subPageName: 'Limited Justice/Chaos Edition',
        pageId
      };
    } else if (requestPath.endsWith('/pages/x3-pro-launch')) {
      return {
        // pageName: 'X3 Pro',
        pageName: document.title,
        subPageName: '',
        pageId
      };
    } else if (requestPath.endsWith('/collections')) {
      return {
        // pageName: 'Products',
        pageName: document.title,
        subPageName: '',
        pageId
      };
    } else if (requestPath.endsWith('/collections/air-series')) {
      return {
        // pageName: 'Products',
        pageName: document.title,
        subPageName: 'Air Series',
        pageId
      };
    } else if (requestPath.endsWith('/collections/ai-smart-glasses')) {
      return {
        // pageName: 'Products',
        pageName: document.title,
        subPageName: 'X Series',
        pageId
      };
    } else if (requestPath.endsWith('/collections/accessories')) {
      return {
        // pageName: 'Products',
        pageName: document.title,
        subPageName: 'Accessories',
        pageId
      };
    } else if (requestPath.endsWith('/blogs/news')) {
      return {
        // pageName: 'Community',
        pageName: document.title,
        subPageName: 'Blogs',
        pageId
      };
    } else if (requestPath.endsWith('/pages/rayneo-member')) {
      return {
        // pageName: 'Community',
        pageName: document.title,
        subPageName: 'RayNeo Member',
        pageId
      };
    } else if (requestPath.endsWith('/pages/rayneo-trade-in')) {
      return {
        // pageName: 'Community',
        pageName: document.title,
        subPageName: 'Trade-in Program',
        pageId
      };
    } else if (requestPath.endsWith('/pages/affiliate-marketing')) {
      return {
        // pageName: 'Community',
        pageName: document.title,
        subPageName: 'Affiliate Program',
        pageId
      };
    } else if (requestPath.endsWith('/pages/support')) {
      return {
       // pageName: 'Support',
       pageName: document.title,
        subPageName: '',
        pageId
      };
    } else if (requestPath.endsWith('/pages/how-to-use')) {
      return {
        // pageName: 'Support',
        pageName: document.title,
        subPageName: 'How to Use',
        pageId
      };
    } else if (requestPath.endsWith('/pages/download')) {
      return {
        // pageName: 'Support',
        pageName: document.title,
        subPageName: 'Download',
        pageId
      };
    }else if (requestPath.endsWith('/pages/contactus')) {
      return {
        // pageName: 'Support',
        pageName: document.title,
        subPageName: 'Contact Us',
        pageId
      };
    }else if (requestPath.endsWith('/policies/terms-of-service')) {
      return {
        // pageName: 'Support',
        pageName: document.title,
        subPageName: 'Terms of Service',
        pageId
      };
    }else if (requestPath.endsWith('/pages/air-series-comparison')) {
      return {
        // pageName: 'Support',
        pageName: document.title,
        subPageName: 'Comparison',
        pageId
      };
    }else if (requestPath.endsWith('/pages/product-compatibilities')) {
      return {
        // pageName: 'Support',
        pageName: document.title,
        subPageName: 'Compatibility',
        pageId
      };
    }else if (requestPath.endsWith('/policies/refund-policy')) {
      return {
        // pageName: 'Support',
        pageName: document.title,
        subPageName: 'Refund Policy',
        pageId
      };
    } else if (requestPath.endsWith('/pages/rayneo-shop')) {
      return {
        // pageName: 'Shop',
        pageName: document.title,
        subPageName: '',
        pageId
      };
    }
    const arr = requestPath.split('/').filter(item => item !== '');
    if (arr.length === 1) {
      return {
        pageName: arr[arr.length - 1],
        subPageName: '',
        pageId
      };
    } else if (arr.length >= 2) {
      return {
        pageName: arr[arr.length - 2],
        subPageName: arr[arr.length - 1],
        pageId
      };
    }
    return {
      pageName: fillEmptyValue(currentContext.pageTitle),
      subPageName: '',
      pageId: fillEmptyValue(currentContext.pageId)
    };
  }

  function detectClientEnvironment(options) {
    const currentOptions = options || {};
    const userAgent = fillEmptyValue(currentOptions.userAgent).toLowerCase();
    const innerWidth = Number(currentOptions.innerWidth) || 0;
    const isAndroid = userAgent.includes('android');
    const isIPadOsDesktopMode = userAgent.includes('macintosh') && userAgent.includes('mobile');
    const isTabletDevice = /ipad|tablet/.test(userAgent);
    const isMobileDevice = /iphone|ipod/.test(userAgent);
    const isAndroidMobile = isAndroid && userAgent.includes('mobile');
    const isDesktopDevice = /windows|macintosh|mac os x|x11|linux/.test(userAgent) && !isAndroid;

    let deviceType = 'desktop';
    if (isTabletDevice || isIPadOsDesktopMode) {
      deviceType = 'tablet';
    } else if (isMobileDevice || isAndroidMobile) {
      deviceType = 'mobile';
    } else if (isAndroid) {
      deviceType = 'tablet';
    } else if (!isDesktopDevice && innerWidth > 0 && innerWidth < 768) {
      deviceType = 'mobile';
    }

    let os = 'unknown';
    if (userAgent.includes('windows')) {
      os = 'windows';
    } else if (userAgent.includes('android')) {
      os = 'android';
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      os = 'ios';
    } else if (userAgent.includes('mac os x') || userAgent.includes('macintosh')) {
      os = 'macos';
    } else if (userAgent.includes('linux')) {
      os = 'linux';
    }

    let browser = 'unknown';
    if (/edg(?:a|ios)?\/|edge\//.test(userAgent)) {
      browser = 'edge';
    } else if (userAgent.includes('opr/')) {
      browser = 'opera';
    } else if (userAgent.includes('samsungbrowser/')) {
      browser = 'samsungbrowser';
    } else if (userAgent.includes('crios/')) {
      browser = 'chrome';
    } else if (userAgent.includes('firefox/')) {
      browser = 'firefox';
    } else if (userAgent.includes('chrome/')) {
      browser = 'chrome';
    } else if (userAgent.includes('safari/')) {
      browser = 'safari';
    } else {
      browser = extractBrowserFromUserAgent(userAgent);
    }

    return {
      deviceType,
      os,
      browser,
      language: fillEmptyValue(currentOptions.language)
    };
  }

  function getReachedScrollDepths(options) {
    const currentOptions = options || {};
    const maxScrollDepth = Number(currentOptions.maxScrollDepth) || 0;
    const reportedDepths = Array.isArray(currentOptions.reportedDepths)
      ? currentOptions.reportedDepths
      : [];
    const reportedDepthSet = new Set(
      reportedDepths
        .map(function normalizeDepth(depth) {
          return Number(depth);
        })
        .filter(function isValidDepth(depth) {
          return !Number.isNaN(depth);
        })
    );

    return depthThresholds.filter(function filterDepth(depth) {
      return depth <= maxScrollDepth && !reportedDepthSet.has(depth);
    });
  }

  function buildCommonFields(fields) {
    const currentFields = fields || {};
    const normalizedFields = {};

    commonFieldKeys.forEach(function normalizeField(key) {
      normalizedFields[key] = fillEmptyValue(currentFields[key]);
    });

    return normalizedFields;
  }

  function buildBasicInfo(fields) {
    const currentFields = fields || {};
    const normalizedFields = {};

    basicInfoKeys.forEach(function normalizeBasicField(key) {
      normalizedFields[key] = fillEmptyValue(currentFields[key]);
    });

    return normalizedFields;
  }

  function buildDataInfo(fields) {
    const currentFields = fields || {};
    const normalizedFields = {};
    const hasTypeField = Object.prototype.hasOwnProperty.call(currentFields, 'type');

    if (hasTypeField) {
      normalizedFields.type = fillEmptyValue(currentFields.type);
    }

    Object.keys(currentFields).forEach(function normalizeField(key) {
      if (key === 'type') {
        return;
      }
      normalizedFields[key] = fillEmptyValue(currentFields[key]);
    });

    return normalizedFields;
  }

  function formatTimestamp(date) {
    const value = date instanceof Date ? date : new Date(date);

    if (Number.isNaN(value.getTime())) {
      return '';
    }

    return value.toISOString();
  }

  function normalizeTrackingToken(value) {
    const normalizedValue = fillEmptyValue(value).trim();

    if (!normalizedValue) {
      return '';
    }

    return normalizedValue
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9\u4e00-\u9fa5]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function resolveElementExposureName(options, elementType) {
    const currentOptions = options || {};
    let candidates = [
      currentOptions.explicitName,
      currentOptions.ariaLabel,
      currentOptions.title,
      currentOptions.altText,
      currentOptions.textContent,
      currentOptions.hrefToken,
      currentOptions.mediaToken
    ];

    if (elementType === 'image' || elementType === 'video') {
      candidates = [
        currentOptions.srcUrl,
        currentOptions.explicitName,
        currentOptions.altText,
        currentOptions.ariaLabel,
        currentOptions.title,
        currentOptions.textContent,
        currentOptions.hrefToken,
        currentOptions.mediaToken,
      ];
    }

    for (let index = 0; index < candidates.length; index += 1) {
      const normalizedCandidate = normalizeTrackingToken(candidates[index]);

      if (normalizedCandidate) {
        return normalizedCandidate;
      }
    }

    return '';
  }

  function resolveElementExposureType(options) {
    const currentOptions = options || {};
    const explicitType = normalizeTrackingToken(currentOptions.explicitType);
    const tagName = fillEmptyValue(currentOptions.tagName).toLowerCase();
    const role = fillEmptyValue(currentOptions.role).toLowerCase();

    if (explicitType) {
      return explicitType;
    }

    if (tagName === 'button' || role === 'button') {
      return 'button';
    }

    if (tagName === 'a' || role === 'link') {
      return 'link';
    }

    if (tagName === 'img' || role === 'img') {
      return 'image';
    }

    if (tagName === 'video') {
      return 'video';
    }

    return 'unknown';
  }

  function resolveElementExposurePosition(options) {
    const currentOptions = options || {};
    const explicitPosition = normalizeTrackingToken(currentOptions.explicitPosition);
    const ancestorTags = Array.isArray(currentOptions.ancestorTags)
      ? currentOptions.ancestorTags.map(function normalizeTag(tag) {
          return fillEmptyValue(tag).toLowerCase();
        })
      : [];
    const ancestorClassNames = Array.isArray(currentOptions.ancestorClassNames)
      ? currentOptions.ancestorClassNames.map(function normalizeClassName(className) {
          return fillEmptyValue(className).toLowerCase();
        })
      : [];
    const combinedHints = ancestorClassNames.join(' ');

    if (explicitPosition) {
      return explicitPosition;
    }

    if (ancestorTags.includes('header') || /header|nav/.test(combinedHints)) {
      return 'header';
    }

    if (ancestorTags.includes('footer') || /footer/.test(combinedHints)) {
      return 'footer';
    }

    if (ancestorTags.includes('aside') || /sidebar|aside/.test(combinedHints)) {
      return 'sidebar';
    }

    if (/hero|banner|slideshow|carousel/.test(combinedHints)) {
      return 'body';
    }

    return 'body';
  }

  const POPUP_HOST_DISPLAY_MAP = {
    'cookie-banner': 'CookieBanner',
    'newsletter-modal': 'NewsletterModal',
    'age-verifier': 'AgeVerifier'
  };

  const POPUP_CONTAINER_TAGS = {
    'cart-drawer': true,
    'search-drawer': true,
    'help-drawer': true,
    'modal-element': true,
    'drawer-element': true,
    'menu-drawer': true,
    'share-drawer': true,
    'back-in-stock-drawer': true,
    'x-modal': true
  };

  const POPUP_WALK_SKIP_TAGS = {
    'overlay-element': true
  };

  function resolvePopupHostDisplayName(element) {
    let drawerName;
    let mapped;
    let tagKey;

    if (!element || !element.tagName) {
      return '';
    }

    tagKey = String(element.tagName).toLowerCase();
    mapped = POPUP_HOST_DISPLAY_MAP[tagKey];

    if (mapped) {
      return mapped;
    }

    drawerName =
      typeof element.getAttribute === 'function'
        ? fillEmptyValue(element.getAttribute('data-drawer'))
        : fillEmptyValue(element.dataset && element.dataset.drawer);

    if (drawerName) {
      return drawerName;
    }

    if (element.id && String(element.id).trim() !== '') {
      return String(element.id);
    }

    return tagKey;
  }

  function findPopupNameForClickContext(startElement, stopAncestor) {
    let node = startElement;

    while (node) {
      if (stopAncestor && node === stopAncestor) {
        break;
      }

      if (typeof document !== 'undefined' && document.documentElement && node === document.documentElement) {
        break;
      }

      if (node.nodeType === 1) {
        const tagKey = String(node.tagName).toLowerCase();
        const drawerName =
          typeof node.getAttribute === 'function'
            ? fillEmptyValue(node.getAttribute('data-drawer'))
            : fillEmptyValue(node.dataset && node.dataset.drawer);

        if (!POPUP_WALK_SKIP_TAGS[tagKey]) {
          if (drawerName || POPUP_HOST_DISPLAY_MAP[tagKey] || POPUP_CONTAINER_TAGS[tagKey]) {
            return resolvePopupHostDisplayName(node);
          }
        }
      }

      node = node.parentElement;
    }

    return '';
  }

  function shouldSkipOverlayPopupTarget(element) {
    if (!element || element.nodeType !== 1) {
      return false;
    }

    return String(element.tagName).toLowerCase() === 'overlay-element';
  }

  function getElementHrefToken(element, originHint) {
    const href = element && typeof element.getAttribute === 'function'
      ? element.getAttribute('href') || ''
      : '';

    if (!href) {
      return '';
    }

    try {
      const parsedUrl = new URL(
        href,
        typeof originHint === 'string' && originHint ? originHint : 'https://shop.example'
      );
      const segments = (parsedUrl.pathname || '/').split('/').filter(Boolean);

      return segments[segments.length - 1] || parsedUrl.hostname || '';
    } catch (error) {
      return '';
    }
  }

  function getElementMediaToken(element, originHint) {
    const sourceUrl = element
      ? element.currentSrc ||
        (typeof element.getAttribute === 'function' && (
          element.getAttribute('src') ||
          element.getAttribute('poster') ||
          element.getAttribute('data-src')
        )) ||
        ''
      : '';

    if (!sourceUrl) {
      return '';
    }

    try {
      const parsedUrl = new URL(
        sourceUrl,
        typeof originHint === 'string' && originHint ? originHint : 'https://shop.example'
      );
      const segments = (parsedUrl.pathname || '/').split('/').filter(Boolean);
      const lastSegment = segments[segments.length - 1] || '';

      return lastSegment ? lastSegment.replace(/\.[a-z0-9]+$/i, '') : parsedUrl.hostname || '';
    } catch (error) {
      return '';
    }
  }

  function extractMediaNameFromUrl(url, originHint) {
    if (!url) {
      return '';
    }

    try {
      const parsedUrl = new URL(
        url,
        typeof originHint === 'string' && originHint ? originHint : 'https://shop.example'
      );
      const segments = (parsedUrl.pathname || '/').split('/').filter(Boolean);
      const lastSegment = segments[segments.length - 1] || '';

      return lastSegment ? lastSegment.replace(/\.[a-z0-9]+$/i, '') : parsedUrl.hostname || '';
    } catch (error) {
      return '';
    }
  }

  function getVideoSourceUrl(videoElement) {
    return videoElement
      ? fillEmptyValue(
          videoElement.currentSrc ||
          (typeof videoElement.getAttribute === 'function' && (
            videoElement.getAttribute('src') ||
            videoElement.getAttribute('poster') ||
            videoElement.getAttribute('data-src')
          )) ||
          ''
        )
      : '';
  }

  function normalizeMediaDuration(duration) {
    const value = Number(duration);

    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function normalizeMediaProgress(fields) {
    const currentFields = fields || {};
    const currentTime = Math.max(0, Number(currentFields.currentTime) || 0);
    const duration = normalizeMediaDuration(currentFields.duration);

    if (!duration) {
      return 0;
    }

    return Math.max(0, Math.min(100, Math.floor((currentTime / duration) * 100)));
  }

  function roundMediaMetric(value, decimalPlaces) {
    const places = Number.isFinite(decimalPlaces) ? decimalPlaces : 3;
    const factor = Math.pow(10, places);

    return Math.round(value * factor) / factor;
  }

  function resolveMediaWatchMetrics(currentTime, duration) {
    const playbackSeconds = Math.max(0, Number(currentTime) || 0);
    const mediaDuration = normalizeMediaDuration(duration);

    if (!playbackSeconds) {
      return {
        watchDuration: 0,
        progress: 0
      };
    }

    const watchDuration = roundMediaMetric(playbackSeconds, 3);
    let progress = 0;

    if (mediaDuration > 0) {
      progress = roundMediaMetric(
        Math.min(100, (playbackSeconds / mediaDuration) * 100),
        3
      );
    }

    return {
      watchDuration: watchDuration,
      progress: progress
    };
  }

  function collectElementAncestorMetadata(element, stopNode) {
    const ancestorTags = [];
    const ancestorClassNames = [];
    let currentNode = element;

    while (currentNode && currentNode !== stopNode) {
      if (currentNode.tagName) {
        ancestorTags.push(String(currentNode.tagName).toLowerCase());
      }

      if (typeof currentNode.className === 'string' && currentNode.className) {
        ancestorClassNames.push(currentNode.className);
      }

      currentNode = currentNode.parentElement;
    }

    return {
      ancestorTags: ancestorTags,
      ancestorClassNames: ancestorClassNames
    };
  }

  function isTrackableElementCandidate(options) {
    const currentOptions = options || {};
    const explicitType = normalizeTrackingToken(currentOptions.explicitType);
    const tagName = fillEmptyValue(currentOptions.tagName).toLowerCase();
    const href = fillEmptyValue(currentOptions.href);
    const mediaSrc = fillEmptyValue(currentOptions.mediaSrc);
    const allowMediaElements = Boolean(currentOptions.allowMediaElements);
    const ariaHidden = fillEmptyValue(currentOptions.ariaHidden).toLowerCase();
    const hidden = Boolean(currentOptions.hidden);
    const disabled = Boolean(currentOptions.disabled);
    const display = fillEmptyValue(currentOptions.display).toLowerCase();
    const visibility = fillEmptyValue(currentOptions.visibility).toLowerCase();

    if (hidden || ariaHidden === 'true' || disabled) {
      return false;
    }

    if (display === 'none' || visibility === 'hidden') {
      return false;
    }

    if (explicitType) {
      return true;
    }

    if (tagName === 'a') {
      return Boolean(href && href !== '#' && href.indexOf('javascript:') !== 0);
    }

    if (allowMediaElements && (tagName === 'img' || tagName === 'video')) {
      return Boolean(mediaSrc);
    }

    return tagName === 'button';
  }

  function buildElementTrackingData(options) {
    const currentOptions = options || {};
    const pageIdentity = currentOptions.pageIdentity || {};
    const trackingContext = currentOptions.trackingContext || {};
    const elementInfo = currentOptions.elementInfo || {};
    const altBasedProductName = fillEmptyValue(elementInfo.altText);
    const fallbackProductName = fillEmptyValue(trackingContext.productTitle);

    const elementType = resolveElementExposureType({
      explicitType: elementInfo.explicitType,
      tagName: elementInfo.tagName,
      role: elementInfo.role
    });

    return {
      pageName: fillEmptyValue(pageIdentity.pageName),
      subPageName: fillEmptyValue(pageIdentity.subPageName),
      elementName: resolveElementExposureName({
        explicitName: elementInfo.explicitName,
        ariaLabel: elementInfo.ariaLabel,
        title: elementInfo.title,
        altText: elementInfo.altText,
        textContent: elementInfo.textContent,
        hrefToken: elementInfo.hrefToken,
        mediaToken: elementInfo.mediaToken,
        srcUrl: elementInfo.srcUrl,
      }, elementType),
      elementType,
      productId: fillEmptyValue(trackingContext.productId),
      productName: altBasedProductName || fallbackProductName,
      position: resolveElementExposurePosition({
        explicitPosition: elementInfo.explicitPosition,
        ancestorTags: elementInfo.ancestorTags,
        ancestorClassNames: elementInfo.ancestorClassNames
      })
    };
  }

  /**
   * 根据跳转目标 URL 推断 toPageName / toPageId（无前端 Liquid 上下文时的兜底，仅路径规则）。
   */
  function guessPageJumpTarget(urlString, originHint) {
    if (!urlString || typeof urlString !== 'string') {
      return {
        pageName: '',
        pageId: ''
      };
    }

    try {
      const baseOrigin =
        typeof originHint === 'string' && originHint
          ? originHint
          : typeof window !== 'undefined' &&
              window.location &&
              window.location.origin
            ? window.location.origin
            : 'https://shop.example';
      const parsedUrl = new URL(urlString, baseOrigin);
      const path = parsedUrl.pathname || '/';

      if (path === '/' || path === '') {
        return {
          pageName: 'HomePage',
          pageId: 'HomePage'
        };
      }

      const segments = path.split('/').filter(Boolean);
      const firstSegment = segments[0];

      function decodeSegment(segment) {
        try {
          return decodeURIComponent(segment);
        } catch (error) {
          return segment;
        }
      }

      if (firstSegment === 'products' && segments[1]) {
        const handle = segments[segments.length - 1];
        const decoded = decodeSegment(handle);

        return {
          pageName: decoded.replace(/-/g, ' '),
          pageId: decoded
        };
      }

      if (firstSegment === 'collections' && segments[1]) {
        const handle = decodeSegment(segments[1]);

        return {
          pageName: handle.replace(/-/g, ' '),
          pageId: handle
        };
      }

      if (firstSegment === 'pages' && segments[1]) {
        const handle = decodeSegment(segments[1]);

        return {
          pageName: handle.replace(/-/g, ' '),
          pageId: handle
        };
      }

      if (firstSegment === 'blogs' && segments.length >= 3) {
        const articleHandle = decodeSegment(segments[2]);

        return {
          pageName: articleHandle.replace(/-/g, ' '),
          pageId: articleHandle
        };
      }

      if (firstSegment === 'blogs' && segments[1]) {
        const handle = decodeSegment(segments[1]);

        return {
          pageName: handle.replace(/-/g, ' '),
          pageId: handle
        };
      }

      const lastSegment = segments[segments.length - 1] || '';
      const decodedLast = decodeSegment(lastSegment);

      return {
        pageName: decodedLast.replace(/-/g, ' '),
        pageId: decodedLast
      };
    } catch (error) {
      return {
        pageName: '',
        pageId: ''
      };
    }
  }

  function buildPendingPageJumpState(fields) {
    const currentFields = fields || {};

    return {
      prePageName: fillEmptyValue(currentFields.pageName),
      preSubPageName: fillEmptyValue(currentFields.subPageName),
      referPage: fillEmptyValue(currentFields.pageUrl),
      enterAt: Number(currentFields.enterAt) || 0,
      leaveAt: Number(currentFields.leaveAt) || 0
    };
  }

  function shouldReportPendingPageJump(options) {
    const currentOptions = options || {};
    const pendingPageJump = currentOptions.pendingPageJump || {};
    const nowMs = Number(currentOptions.nowMs) || 0;
    const maxAgeMs = Number(currentOptions.maxAgeMs) || 0;
    const currentOrigin = fillEmptyValue(currentOptions.currentOrigin);
    const currentUrl = fillEmptyValue(currentOptions.currentUrl);
    const leaveAt = Number(pendingPageJump.leaveAt) || 0;
    const enterAt = Number(pendingPageJump.enterAt) || 0;

    if (!pendingPageJump.prePageName) {
      return false;
    }

    if (!pendingPageJump.referPage || !leaveAt || !enterAt || leaveAt < enterAt) {
      return false;
    }

    if (currentUrl && currentUrl === pendingPageJump.referPage) {
      return false;
    }

    if (!currentOrigin) {
      return false;
    }

    try {
      if (new URL(pendingPageJump.referPage).origin !== currentOrigin) {
        return false;
      }
    } catch (error) {
      return false;
    }

    if (maxAgeMs > 0 && nowMs > 0 && nowMs - leaveAt > maxAgeMs) {
      return false;
    }

    return true;
  }

  return {
    // 统一把 null / undefined 转成空字符串，避免上报字段缺失或类型不一致
    fillEmptyValue: fillEmptyValue,
    // 根据 Shopify 页面上下文推导 pageName / subPageName / pageId
    resolvePageIdentity: resolvePageIdentity,
    // 从 UA、窗口宽度、语言中提取 deviceType / os / browser
    detectClientEnvironment: detectClientEnvironment,
    // 根据当前最大滚动深度，算出本次新跨过了哪些 25/50/75/100 档位
    getReachedScrollDepths: getReachedScrollDepths,
    // 补齐通用字段并统一转字符串
    buildCommonFields: buildCommonFields,
    // 仅保留 basicInfo 里需要的固定字段
    buildBasicInfo: buildBasicInfo,
    // 组装 dataInfo，并保证 type 排在第一位
    buildDataInfo: buildDataInfo,
    // 把 Date 格式化成埋点接口要求的时间字符串
    formatTimestamp: formatTimestamp,
    // 把按钮/链接文案归一成适合上报的 token，如 Buy Now -> buy_now
    normalizeTrackingToken: normalizeTrackingToken,
    // 根据 data 属性、aria-label、标题、文本等推导 elementName
    resolveElementExposureName: resolveElementExposureName,
    // 根据 data-track-type、标签或 role 识别当前元素类型
    resolveElementExposureType: resolveElementExposureType,
    // 根据祖先语义标签 / class 线索推断元素所在区域
    resolveElementExposurePosition: resolveElementExposurePosition,
    // 从链接元素的 href 中提取适合命名兜底的 token
    getElementHrefToken: getElementHrefToken,
    // 从图片/视频资源 URL 中提取适合命名兜底的 token
    getElementMediaToken: getElementMediaToken,
    // 从视频 URL 中提取文件名并去掉扩展名
    extractMediaNameFromUrl: extractMediaNameFromUrl,
    // 从 video 元素读取当前稳定的播放资源 URL
    getVideoSourceUrl: getVideoSourceUrl,
    // 统一归一化媒体总时长
    normalizeMediaDuration: normalizeMediaDuration,
    // 统一计算 0-100 的整数媒体进度
    normalizeMediaProgress: normalizeMediaProgress,
    resolveMediaWatchMetrics: resolveMediaWatchMetrics,
    // 收集元素祖先标签和 class 信息，供 position 推导使用
    collectElementAncestorMetadata: collectElementAncestorMetadata,
    // 判断当前节点是否属于可跟踪的点击/曝光候选元素
    isTrackableElementCandidate: isTrackableElementCandidate,
    // 弹窗/抽屉宿主显示名（与 popup_exposure 一致）
    resolvePopupHostDisplayName: resolvePopupHostDisplayName,
    // 从点击目标向上查找最近弹窗宿主，用于 element_click.popupName
    findPopupNameForClickContext: findPopupNameForClickContext,
    // afterShow 目标为遮罩层时不作为弹窗曝光主体
    shouldSkipOverlayPopupTarget: shouldSkipOverlayPopupTarget,
    // 统一构建元素类埋点共用字段
    buildElementTrackingData: buildElementTrackingData,
    // 仅凭目标 URL 粗略推断页面跳转的 toPageName / toPageId
    guessPageJumpTarget: guessPageJumpTarget,
    // 把上一页离开时缓存的跳转信息整理成统一结构
    buildPendingPageJumpState: buildPendingPageJumpState,
    // 判断当前页是否应该补报上一跳 pageJump
    shouldReportPendingPageJump: shouldReportPendingPageJump
  };
});
